import type { FC} from 'react';
import { type JSX } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks/redux';
import { setLeaveAdCreationSteps } from '../../../store/reducers/modals-drawers.slice';
import CommonButton from '../../../../shared/components/CommonButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LeaveAdCreativeStepsModal: FC = (): JSX.Element => {
  const modalOpened = useAppSelector((state) => state.editorModalsDrawersReducer.leaveAdCreationSteps);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleClose = (agreed: boolean) => {
    dispatch(setLeaveAdCreationSteps({ isOpened: false, pathNavigateTo: null }));
    const routeToNav = modalOpened.pathNavigateTo;
    if (agreed && routeToNav) {
      navigate(routeToNav);
    }
  };

  return (
    <Dialog open={modalOpened.isOpened} onClose={() => handleClose(false)}>
      <DialogTitle>{t('leaveAdCreation')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{t('leaveAdCreationWarning')}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <CommonButton onClick={() => handleClose(false)}>{t('stayOnCreation')}</CommonButton>
        <CommonButton disableRipple color="error" onClick={() => handleClose(true)}>
          {t('leaveCreation')}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveAdCreativeStepsModal;
